/*
 * @Description: 数据分析伪代码公用方法实现
 * @Author: shenah
 * @Date: 2023-04-11 17:04:43
 * @LastEditors: shenah
 * @LastEditTime: 2023-12-25 16:47:44
 */
function customSort(sortArrStr, originArr, field) {
  let sortArrStrLength = sortArrStr.length;
  let beforeArr = new Array(sortArrStrLength);
  let diffArr = [];
  originArr.forEach((item) => {
    let sortArrIndex = sortArrStr.indexOf(item[field]);
    if (sortArrIndex > -1) {
      beforeArr[sortArrIndex] = item;
    } else {
      diffArr.push(item);
    }
  });
  beforeArr = beforeArr.filter(Boolean);
  return [...beforeArr, ...diffArr];
}
function judgeSortType(str) {
  if (Array.isArray(str)) {
    return "array";
  }
  let strNum = Number(str);
  if (str === "升序" || strNum === 1) {
    return "asc";
  } else if (str === "降序" || strNum === -1) {
    return "desc";
  }
  return "default";
}
export default {
  // 刷新方法
  refreshDataEvent() {
    this.init();
    return this;
  },
  // 添加数据
  appendDataEvent(data) {
    if (Array.isArray(this.data)) {
      if (Array.isArray(data)) {
        this.data.push([...data]);
      } else {
        this.data.push(data);
      }
      this.extraSpecialRender();
    }
    return this;
  },
  /**
   * @description: 删除数据
   *@param {string | number} sort 下标(传入1就是删除第一个,依次类推)删除、以及名称删除
   * @param {string} field 支持传入动态字段
   */
  delDataEvent(str, field = "name") {
    if (Array.isArray(this.data)) {
      let isNumber = typeof str === "number";
      let argLength = [...arguments].filter(
        (item) => item !== undefined && item !== null
      ).length;
      let index = 0;
      if (isNumber && argLength === 1) {
        index = str - 1;
      } else {
        index = this.data.findIndex((item) => item[field] == str);
        if (index === -1) {
          return this;
        }
      }
      this.data.splice(index, 1);
      this.extraSpecialRender();
    }
    return this;
  },
  // 还原数据
  resetDataEvent() {
    // this.data = _.cloneDeep(this.pureData);
    // if (this.componentType === 'generalTable') {
    //   this.header = _.cloneDeep(this.pureHeader);
    // }
    // 调用刷新的方法
    this.refreshDataEvent();
    return this;
  },
  setDataEvent(data) {
    //目前就只有时间线有这个方法
  },
  getCurrentDataEvent(data) {
    //目前就只有时间线有这个方法
  },
};
